export enum PerfilEnum {
  Admin = 'AD',
  Gestor = 'GE',
  Tecnico = 'TE',
  Empresa = 'EM'
}
